<template>
  <v-list-item
    :to="{
      name: 'activist_taken_task_detail',
      params: { task_id: task.task_id, taken_task_id: task.id },
    }"
  >
    <v-list-item-content>
      <v-list-item-title v-html="task.user_name"></v-list-item-title>
      <v-list-item-title v-html="userRegion"></v-list-item-title>
      <v-list-item-subtitle>
        <div>
          <v-icon :color="statusIconColor">{{ statusIcon }}</v-icon>
          {{ statusDisplay }}
        </div>
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import {
  getTakenStatusIcon,
  getTakenStatusIconColor,
  getTakenTaskStatusDisplay,
} from '@/api/activist/task'

export default {
  name: 'TakenTaskListItem',
  props: {
    task: {
      type: Object,
      default: () => {
        return {
          status: 0,
          id: '',
        }
      },
    },
  },
  data() {
    return {}
  },
  computed: {
    userRegion() {
      return this.task.user_region && this.task.user_region.key ? this.task.user_region.title : ''
    },
    user() {
      const region =
        this.task.user_region && this.task.user_region.key ? this.task.user_region.name : ''
      return `${this.task.user_name} ${region}`
    },
    statusIcon() {
      return getTakenStatusIcon(this.task.status)
    },
    statusIconColor() {
      return getTakenStatusIconColor(this.task.status)
    },
    statusDisplay() {
      return getTakenTaskStatusDisplay(this.task.status)
    },
  },
}
</script>
